<template>

  <div class="content" v-if="post">
    <div class="title-sidebar">
      {{ $t('dash.planner.sidebar.title') }} <br/>
      <span class="date" v-if="post.status == 'posted' && post.page[0] && post.page[0].isScheduledPost">{{ `${$t('dash.detail.scheduled_date')} : ${formatDate(post.posted_date, 'DD/MM/YY HH:mm')}`}}</span>
      <span class="date" v-else-if="post.status == 'posted'">{{ `${$t('dash.detail.posted_date')} : ${formatDate(post.posted_date, 'DD/MM/YY HH:mm')}`}}</span>
      <span class="date" v-else-if="post.status == 'scheduled'">{{ `${$t('dash.detail.scheduled_date')} : ${formatDate(post.scheduled_date, 'DD/MM/YY HH:mm')}`}}</span>
      <span class="date" v-else-if="post.status == 'preview' && sectionPlanner">{{ `${$t('dash.detail.preview_date')} : ${formatDate(post.preview_date, 'DD/MM/YY HH:mm')}`}}</span>
      <span class="date" v-else-if="post.status == 'slot'">{{ `${$t('dash.detail.slot_date')} : ${formatDate(post.date, 'DD/MM/YY HH:mm')}`}}</span>
    </div>
    <template v-if="['scheduled', 'posted', 'failed', 'draft'].includes(post.status)">
      <div class="validated-post" v-if="post.page[0] && post.page[0].wait_validation && getWaitValidation">
        <span class="name">{{ getWaitValidation.name }}</span>
        {{ $t('dash.notification.validate_at') }}
        <Tooltip
          :text="dateFormat(getWaitValidation.date)"
          position="top"
        >
          <span>{{ dateFromNow(getWaitValidation.date) }}</span>
          &nbsp;
        </Tooltip>
      </div>

      <vs-button class="btnx validated-post-btn" type="filled"
          v-if="post.status == 'draft' 
                && ((openPostSidebar && openPostSidebar.id == post.id) || (post.page && post.page[0] && post.page[0].affectedTo && ((post.page[0].affectedTo.user && post.page[0].affectedTo.user.id == getUserId) || (post.page[0].affectedTo.users && post.page[0].affectedTo.users.find(u => u.id == getUserId)))))"
        @click.prevent="draftToSchedule()"
      >
        {{$t('dash.button.validate.scheduled_post')}}
      </vs-button>

      <template v-else-if="['scheduled', 'draft'].includes(post.status) && !(invite || ['Viewer', 'Writter'].includes(getUserRole) )">
        <div class="affected_to">
          <div class="affected_to-title">
            {{ $t('dash.post.affected_to.title') }}
            <div class="add-user" @click="popupSelectUser = true" v-if="!(post.page && post.page[0] && post.page[0].affectedTo) && (!openPostSidebar || openPostSidebar.id != post.id)">
              <i class="fa-solid fa-user-plus"></i>
            </div>
            <div class="list" v-else-if="post.page[0].affectedTo.users && post.page[0].affectedTo.users.length > 1">
              <ul>
                <li :key="indexU" v-for="(user,indexU) in post.page[0].affectedTo.users">
                  {{ `${user.lastname} ${user.firstname}` }}<br/>({{ user.email }})
                </li>
              </ul>
            </div>
            <div class="list" v-else-if="post.page[0].affectedTo.user">
              {{ `${post.page[0].affectedTo.user.lastname} ${post.page[0].affectedTo.user.firstname}` }}<br/>({{ post.page[0].affectedTo.user.email }})
            </div>
          </div>
        </div>
        <vs-popup class="overlay groups shared-planner affected_to post-sidebar" 
              :title="$t('dash.inbox.event.affected_to.title')" 
              :active.sync="popupSelectUser">
                  
          <component-users-selector
            v-if="popupSelectUser"
            v-on:submit="addAffectedToPost"
            :manager="true"
          ></component-users-selector>
  
        </vs-popup>
      </template>

      
      <vs-button class="btnx validated-post-btn" type="filled" 
          v-if="['scheduled', 'draft'].includes(post.status)
            && ((post.page && post.page[0] && post.page[0].affectedTo && ((post.page[0].affectedTo.user && post.page[0].affectedTo.user.id == getUserId) || (post.page[0].affectedTo.users && post.page[0].affectedTo.users.find(u => u.id == getUserId))) && !(post.status == 'draft' && ['Admin', 'Editor'].includes(getUserRole)))
                  || (invite || getUserRole == 'Viewer'))
           // && (invite || getUserRole == 'Viewer') 
           && checkWaitValidation"
        @click.prevent="validatePostInvite()"
      >
        {{$t('dash.button.validate.scheduled_post')}}
      </vs-button>
    </template>
    <div class="history" v-if="post.page && post.page[0] && post.page[0].log && post.page[0].log.length && !(invite || getUserRole == 'Viewer')">
      <div class="history-title" @click="showLogs = !showLogs">{{ $t('dash.detail.history') }} <span>{{ $t(`dash.detail.history.${showLogs ? 'minimize' : 'maximize'}`) }}</span></div>
      <vs-collapse v-if="showLogs" class="log">
        <vs-collapse-item v-for="(log,index) in post.page[0].log" :key="`log-${index}`" :disabled="isDifferencesEmpty(log.differences)">
          <div slot="header">
          <Tooltip
            :text="`${getLogUser(log.user).name}`"
            position="top"
          >
            <img class="image-user" v-if="getLogUser(log.user).avatar && getLogUser(log.user).avatar != 'null'" :alt="getLogUser(log.user).name" :src="getLogUser(log.user).avatar"/>
            <img class="image-user" src="img/avatar.jpg" v-else/>
          </Tooltip>
            <div class="type-date">{{ $t(`dash.detail.history.log-${log.created_at ? 'created' : (log.removed_at ? 'removed' : 'updated')}${log.isDraft ? '-draft' : (log.isScheduled ? '-scheduled' : '')}`) }} {{ getDateLog(log) }}</div>
            <div class="by" v-if="getLogUser(log.user).email">{{ $t(`dash.detail.history.log-by`) }} {{ getLogUser(log.user).email }}</div>
          </div>
          <div class="content-log">

            <div class="differences" v-if="log.differences && log.differences.filter(d => d).length">
              <div class="difference-title">{{ $t('dash.detail.history.change') }}</div>
              <ul>
                <li :key="indexDiff" v-for="(difference,indexDiff) in log.differences.filter(d => d)" v-show="showLogDifference(difference)">
                  <div class="name">{{ $t(`dash.detail.history.difference.${difference.name}`) }}</div>
                  <Tooltip
                    :text="$t('dash.detail.history.difference.oldValue')"
                    position="top"
                  >
                    <ul v-if="difference.name == 'bot'" class="old-value">
                      <li v-for="botId in difference.oldValue" :key="botId">
                        {{ getPageNameByBotId(botId) }}
                      </li>
                    </ul>
                    <ul v-else-if="difference.name == 'validMentions'" class="old-value">
                      <div v-for="(mentions, idM) in difference.oldValue" :key="idM">
                        <li v-for="mention in mentions" :key="mention.network" v-show="mention.network == post._bots[0].page.network">
                          {{ `MENTIONS-${idM+1} : ${mention.value || mention.word}` }}
                        </li>
                      </div>
                    </ul>
                    <ul v-else-if="difference.name == 'editPostValue'" class="old-value">
                      <div v-for="(editPostValue, idM) in difference.oldValue" :key="idM">
                        <li v-if="editPostValue.page == post._bots[0].page.id && editPostValue.title">
                          <div class="title" v-if="editPostValue.title">{{ $t('dash.detail.history.difference.editPostValue.title') }} {{ editPostValue.title }}</div>
                        </li>
                        <li v-if="editPostValue.page == post._bots[0].page.id && editPostValue.scheduling">
                          <div class="scheduling" v-if="editPostValue.scheduling">{{ $t('dash.detail.history.difference.editPostValue.scheduling') }} {{ dateFormat(editPostValue.scheduling.date, editPostValue.scheduling.time.HH, editPostValue.scheduling.time.mm) }}</div>
                        </li>
                      </div>
                    </ul>
                    <div class="old-value" v-else-if="difference.name == 'scheduling'">{{ dateFormat(difference.oldValue.lastScheduled || difference.oldValue.date) }}</div>
                    <div class="old-value" v-else-if="['filename', 'videoname'].includes(difference.name) && ![$t('dash.message.no.file'), $t('dash.message.no.video')].includes(difference.oldValue)">
                      <a :href="`https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads/${difference.oldValue}`" target="_blank">{{ difference.oldValue }}</a>
                    </div>
                    <ul v-else-if="['tiktokOptions', 'youtubeOptions'].includes(difference.name)" class="old-value">
                      <li v-for="(option, idM) in objectToArray(JSON.parse(difference.oldValue))" :key="idM"  v-show="!objectToArray(JSON.parse(difference.newValue))[idM] || option.name != objectToArray(JSON.parse(difference.newValue))[idM].name || option.value != objectToArray(JSON.parse(difference.newValue))[idM].value">
                        <!-- {{ `${option.name} : ${option.value}` }} -->
                        {{ $t(`dash.detail.history.difference.${difference.name}.${option.name}`) }} : {{ option.value }}
                      </li>
                    </ul>
                    <ul v-else-if="['instagramLinkPosition', 'pollStory', 'sliderStory'].includes(difference.name) && difference.oldValue" class="old-value">
                      <li v-for="(option, idM) in objectToArray(difference.oldValue)" :key="idM" v-show="!difference.newValue || !objectToArray(difference.newValue)[idM] || option.name != objectToArray(difference.newValue)[idM].name || option.value != objectToArray(difference.newValue)[idM].value">
                        <!-- {{ `${option.name} : ${option.value}` }} -->
                        {{ $t(`dash.detail.history.difference.${difference.name}.${option.name}`) }} : {{ option.value }}
                      </li>
                    </ul>
                    <ul v-else-if="['instagramTexts', 'storyMentions'].includes(difference.name)" class="old-value">
                      <li v-for="(text, idT) in difference.oldValue" :key="idT" class="decimal" v-show="JSON.stringify(text) != JSON.stringify(difference.newValue[idT])">
                        <ul>
                          <li v-for="(option, idM) in objectToArray(text)" :key="idM" v-show="!objectToArray(difference.newValue[idT])[idM] || option.name != objectToArray(difference.newValue[idT])[idM].name || option.value != objectToArray(difference.newValue[idT])[idM].value">
                            <!-- {{ `${option.name} : ${option.value}` }} -->
                            {{ $t(`dash.detail.history.difference.${difference.name}.${option.name}`) }} : {{ option.value }}
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <ul v-else-if="['selectedGifs'].includes(difference.name)" class="old-value">
                      <li v-for="(gif, idT) in difference.oldValue" :key="idT" >
                        <ul>
                          <li>{{ $t(`dash.detail.history.difference.selectedGifs.title`) }} : {{ gif.title }}</li>
                          <li><img :src="gif.images.downsized.url" class="gif"/></li>
                          <li v-if="!difference.newValue[idT] || difference.newValue[idT].w != gif.w">{{ $t(`dash.detail.history.difference.selectedGifs.w`) }} : {{ gif.w }}</li>
                          <li v-if="!difference.newValue[idT] || difference.newValue[idT].h != gif.h">{{ $t(`dash.detail.history.difference.selectedGifs.h`) }} : {{ gif.h }}</li>
                          <li v-if="!difference.newValue[idT] || difference.newValue[idT].x != gif.x">{{ $t(`dash.detail.history.difference.selectedGifs.x`) }} : {{ gif.x }}</li>
                          <li v-if="!difference.newValue[idT] || difference.newValue[idT].y != gif.y">{{ $t(`dash.detail.history.difference.selectedGifs.y`) }} : {{ gif.y }}</li>
                        </ul>
                      </li>
                    </ul>
                    <ul v-else-if="difference.name == 'multipleImages'" class="old-value">
                      <div v-for="(image, idM) in difference.oldValue" :key="idM">
                        <li>
                          <a :href="image.url" target="_blank">{{ image.url.split('/').pop() }}</a>
                          <div class="order" v-if="image[post.page[0].network] >= 0">{{ $t('dash.detail.history.difference.multipleImages.order') }} {{ image[post.page[0].network] + 1 }}</div>
                          <div class="ratio" v-if="post.page[0].network == 'instagram'">{{ $t('dash.detail.history.difference.multipleImages.ratio') }} {{ $t(`dash.detail.history.difference.multipleImages.ratio.${image.ratio}`) }}</div>
                        </li>
                      </div>
                    </ul>
                    <ul v-else-if="difference.name == 'multipleMedias'" class="old-value">
                      <div v-for="(media, idM) in difference.oldValue" :key="idM">
                        <li>
                          {{ idM + 1 }} - <a :href="media.url" target="_blank">{{ media.url.split('/').pop() }}</a>
                        </li>
                      </div>
                    </ul>
                    <div class="old-value" v-else-if="difference.name == 'instagramBackgroundColor'"><span v-if="difference.oldValue" class="color-sample" :style="`background:rgba(${difference.oldValue[0]},${difference.oldValue[1]},${difference.oldValue[2]},${difference.oldValue[3]});`"></span>{{ difference.oldValue }}</div>
                    <div class="old-value" v-else>{{ $t(JSON.stringify(difference.oldValue)) }}</div>
                  </Tooltip>
                  <Tooltip
                    :text="$t('dash.detail.history.difference.newValue')"
                    position="top"
                  >
                    <ul v-if="difference.name == 'bot'" class="new-value">
                      <li v-for="botId in difference.newValue" :key="botId">
                        {{ getPageNameByBotId(botId) }}
                      </li>
                    </ul>
                    <ul v-else-if="difference.name == 'validMentions'" class="new-value">
                      <div v-for="(mentions, idM) in difference.newValue" :key="idM">
                        <li v-for="mention in mentions" :key="mention.network" v-show="mention.network == post._bots[0].page.network">
                          {{ `MENTIONS-${idM+1} : ${mention.value || mention.word}` }}
                        </li>
                      </div>
                    </ul>
                    <ul v-else-if="difference.name == 'editPostValue'" class="new-value">
                      <div v-for="(editPostValue, idM) in difference.newValue" :key="idM">
                        <li v-if="editPostValue.page == post._bots[0].page.id && editPostValue.title">
                          <div class="title" v-if="editPostValue.title">{{ $t('dash.detail.history.difference.editPostValue.title') }} {{ editPostValue.title }}</div>
                        </li>
                        <li v-if="editPostValue.page == post._bots[0].page.id && editPostValue.scheduling">
                          <div class="scheduling" v-if="editPostValue.scheduling">{{ $t('dash.detail.history.difference.editPostValue.scheduling') }} {{ dateFormat(editPostValue.scheduling.date, editPostValue.scheduling.time.HH, editPostValue.scheduling.time.mm) }}</div>
                        </li>
                      </div>
                    </ul>
                    <div class="new-value" v-else-if="difference.name == 'scheduling'">{{ dateFormat(difference.newValue.lastScheduled || difference.newValue.date) }}</div>
                    <div class="new-value" v-else-if="['filename', 'videoname'].includes(difference.name)">
                      <a :href="`https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads/${difference.newValue}`" target="_blank">{{ difference.newValue }}</a>
                    </div>
                    <div class="new-value" v-else-if="['videos'].includes(difference.name) && getVideoName(difference.newValue)">
                      <a :href="`https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads/${getVideoName(difference.newValue)}`" target="_blank">{{ getVideoName(difference.newValue) }}</a>
                    </div>
                    <ul v-else-if="['tiktokOptions', 'youtubeOptions'].includes(difference.name)" class="new-value">
                      <li v-for="(option, idM) in objectToArray(JSON.parse(difference.newValue))" :key="idM" v-show="!objectToArray(JSON.parse(difference.oldValue))[idM] || option.name != objectToArray(JSON.parse(difference.oldValue))[idM].name || option.value != objectToArray(JSON.parse(difference.oldValue))[idM].value">
                        <!-- {{ `${option.name} : ${option.value}` }} -->
                        {{ $t(`dash.detail.history.difference.${difference.name}.${option.name}`) }} : {{ option.value }}
                      </li>
                    </ul>
                    <ul v-else-if="['instagramLinkPosition', 'pollStory', 'sliderStory'].includes(difference.name) && difference.newValue" class="new-value">
                      <li v-for="(option, idM) in objectToArray(difference.newValue)" :key="idM" v-show="!difference.oldValue || !objectToArray(difference.oldValue)[idM] || option.name != objectToArray(difference.oldValue)[idM].name || option.value != objectToArray(difference.oldValue)[idM].value">
                        {{ $t(`dash.detail.history.difference.${difference.name}.${option.name}`) }} : {{ option.value }}
                      </li>
                    </ul>
                    <ul v-else-if="['instagramTexts', 'storyMentions'].includes(difference.name)" class="new-value">
                      <li v-for="(text, idT) in difference.newValue" :key="idT" class="decimal" v-show="JSON.stringify(text) != JSON.stringify(difference.oldValue[idT])">
                        <ul>
                          <li v-for="(option, idM) in objectToArray(text)" :key="idM" v-show="!difference.oldValue[idT] || !objectToArray(difference.oldValue[idT])[idM] || option.name != objectToArray(difference.oldValue[idT])[idM].name || option.value != objectToArray(difference.oldValue[idT])[idM].value">
                            <!-- {{ `${option.name} : ${option.value}` }} -->
                            {{ $t(`dash.detail.history.difference.${difference.name}.${option.name}`) }} : {{ option.value }}
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <ul v-else-if="['selectedGifs'].includes(difference.name)" class="new-value">
                      <li v-for="(gif, idT) in difference.newValue" :key="idT">
                        <ul>
                          <li>{{ $t(`dash.detail.history.difference.selectedGifs.title`) }} : {{ gif.title }}</li>
                          <li><img :src="gif.images.downsized.url" class="gif"/></li>
                          <li v-if="!difference.oldValue[idT] || difference.oldValue[idT].w != gif.w">{{ $t(`dash.detail.history.difference.selectedGifs.w`) }} : {{ gif.w }}</li>
                          <li v-if="!difference.oldValue[idT] || difference.oldValue[idT].h != gif.h">{{ $t(`dash.detail.history.difference.selectedGifs.h`) }} : {{ gif.h }}</li>
                          <li v-if="!difference.oldValue[idT] || difference.oldValue[idT].x != gif.x">{{ $t(`dash.detail.history.difference.selectedGifs.x`) }} : {{ gif.x }}</li>
                          <li v-if="!difference.oldValue[idT] || difference.oldValue[idT].y != gif.y">{{ $t(`dash.detail.history.difference.selectedGifs.y`) }} : {{ gif.y }}</li>
                        </ul>
                      </li>
                    </ul>
                    <ul v-else-if="difference.name == 'multipleImages'" class="new-value">
                      <div v-for="(image, idM) in difference.newValue" :key="idM">
                        <li>
                          <a :href="image.url" target="_blank">{{ image.url.split('/').pop() }}</a>
                          <div class="order" v-if="image[post.page[0].network] >= 0">{{ $t('dash.detail.history.difference.multipleImages.order') }} {{ image[post.page[0].network] + 1 }}</div>
                          <div class="ratio" v-if="post.page[0].network == 'instagram'">{{ $t('dash.detail.history.difference.multipleImages.ratio') }} {{ $t(`dash.detail.history.difference.multipleImages.ratio.${image.ratio}`) }}</div>
                        </li>
                      </div>
                    </ul>
                    <ul v-else-if="difference.name == 'multipleMedias'" class="new-value">
                      <div v-for="(media, idM) in difference.newValue" :key="idM">
                        <li>
                          {{ idM + 1 }} - <a :href="media.url" target="_blank">{{ media.url.split('/').pop() }}</a>
                        </li>
                      </div>
                    </ul>
                    <div class="new-value" v-else-if="difference.name == 'instagramBackgroundColor'"><span v-if="difference.newValue" class="color-sample" :style="`background:rgba(${difference.newValue[0]},${difference.newValue[1]},${difference.newValue[2]},${difference.newValue[3]});`"></span>{{ difference.newValue }}</div>
                    <div class="new-value" v-else>{{ $t(JSON.stringify(difference.newValue)) }}</div>
                  </Tooltip>
                </li>
              </ul>
            </div>
          </div>
        </vs-collapse-item>
      </vs-collapse>
    </div>
    <div class="post" v-if="post && post.status != 'slot'">
      <div class="info" v-if="post.status == 'draft' && !(invite || getUserRole == 'Viewer') && editDraftNotAllowed">
        Le brouillon ne peut pas être modifié car il est attribué à certaines pages auxquelles vous n’avez pas accès.
        Veuillez vous rapprocher de votre administrateur afin d’obtenir les droits.
      </div>
      <div class="failed" v-if="post.status == 'failed'">
        {{$t('dash.post.failed.tooltip')}}
        <span v-if="post.page.length && post.page[0].network == 'twitter' && post.page[0].post_number == 'duplicate'">Duplicate</span>
        <span v-else-if="post.page.length && post.page[0].status == 4 && post.page[0].post_number == '[object Object]'">{{ $t('dash.bots.error.title') }}</span>
        <span v-else-if="post.page.length && post.page[0].status == 4">{{ post.page[0].post_number }}</span>
      </div>
      <div class="post-selected" v-else>
        <span v-if="sectionPlanner">{{$t('dash.post.selected')}}</span>

        <vs-button class="btnx" type="filled" 
          v-if="['scheduled', 'draft'].includes(post.status) && !(post._bots[0].page.isGroup && post._bots[0].page.network == 'facebook') && !(invite || getUserRole == 'Viewer') && (['Admin', 'Editor'].includes(getUserRole) || (getUserRole == 'Writter' && post.status == 'draft'))"
          @click.prevent="editPost(post._bots[0].page.id, post._id, post.status, null, post._bots)" 
          :disabled="hasAccessAllPage || editDraftNotAllowed"
          data-qa="post-sidebar-edit"
        >
          {{$t('dash.button.edit.post')}}
        </vs-button>
        <vs-button class="btnx" type="filled" 
          v-if="post.status == 'preview' && !(invite || getUserRole == 'Viewer')"
          @click.prevent="editPost(post._bots[0].page.id, post._id, post.status, post.preview_date, post._bots)"  
          data-qa="post-sidebar-edit"
        >
          {{$t('dash.button.edit.post')}}
        </vs-button>
        <vs-button class="btnx" type="filled" 
          v-if="post.status == 'posted' && ['facebook', 'twitter', 'linkedin', 'pinterest', 'google', 'youtube', 'threads'].includes(post._bots[0].page.network) && !(post._bots[0].page.network ===  'linkedin' && !/^[0-9]+$/.test(post._bots[0].page.network_id)) && !(post.page && post.page[0] && post.page[0].story)"
          @click.prevent="showPost(post._bots[0].page, post)" 
        >
          {{$t('dash.posts.view')}}
        </vs-button>
      </div>
      <div class="slot" v-if="post && post.status != 'slot'" :id="`preview-post-${post._bots[0].id}`" :ref="`preview-post-${post._bots[0].id}`">
        <preview-post 
          :page="post._bots[0].page" 
          :post="post" 
          :key="post._id" 
          :retweet="post._bots[0].page.network == 'twitter' && ['posted', 'scheduled'].includes(post.status) && post.page[0] && post.page[0].is_retweet ? post._bots[0].page : null"
          :activeMentionsAutoReplace="['scheduled', 'direct'].includes(post.status) || (['posted', 'failed', 'removed'].includes(post.status) && post.page[0] && (post.page[0].is_manual_post || post.page[0].isManualPost)) ? false : true" 
          :activeHashtagsAutoAdd="['scheduled', 'direct'].includes(post.status) || (['posted', 'failed', 'removed'].includes(post.status) && post.page[0] && (post.page[0].is_manual_post || post.page[0].isManualPost)) ? false : true"
          :activePrefixSuffix="['scheduled', 'direct'].includes(post.status) || (['posted', 'failed', 'removed'].includes(post.status) && post.page[0] && (post.page[0].is_manual_post || post.page[0].isManualPost)) || (post.status == 'draft' && post.draft && post.draft.data && !post.draft.data.activePrefixSuffix) ? false : true"
          :videoReel="post.page && post.page[0] ? post.page[0].videoReel : false"
          :typePost="post.status == 'draft' && post.typePost ? post.typePost : undefined"
          :validMentions="post.status == 'draft' && post.data.validMentions ? post.data.validMentions : undefined"
          :validHashtags="post.status == 'draft' && post.data.validHashtags ? post.data.validHashtags : undefined"
        ></preview-post>
      </div>
    </div>
    
    <div class="cta" :class="post.status">

      <div class="change-news" v-if="post.status == 'preview' && sectionPlanner && !(invite || ['Writter', 'Viewer'].includes(getUserRole))">
        <div class="label">{{ $t('dash.select.news.label') }}</div>
        <vs-select
          autocomplete
          class="select-news"
          :placeholder="$t('dash.select.news')"
          v-model="changeNews"
        >
          <vs-select-item :key="index" :value="news._id" :text="news.title" v-for="(news,index) in gridData.posts.filter(p => !p.page[0] || (p.page[0] && p.page[0].status != 1 && p.page[0].status != 2))" />
        </vs-select>
        <vs-button
          class="page-btn"
          vs-type="filled"
          color="#2F1937"
          @click.prevent="changePost(post)"
          :disabled="!changeNews"
        >{{$t('dash.button.change.post')}}</vs-button>
      </div>

      <div class="stats"  v-if="post.status == 'posted' && post.page[0] && post.stats">
        <div class="title">{{ $t('dash.table.title.stats') }} :</div>
        <ul 
          v-if="post.page[0] && post.stats && post.page[0].network == 'facebook'" 
          :data="post.stats.find(i => i.name == 'post_impressions').values[0].value" 
        >
          <li>
            <img class="icon-white" src="../../assets/img/rss/icon_vues.svg" alt="vues">
            <p>{{ post.stats.find(i => i.name == 'post_impressions').values[0].value }}</p>
          </li>
          <li>
            <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="likes">
            <p>{{ post.stats.find(i => i.name == 'post_reactions_like_total').values[0].value }}</p>
          </li>
          <li>
            <img class="icon-white" src="../../assets/img/rss/icon_clicks.svg" alt="clicks">
            <p>{{ post.stats.find(i => i.name == 'post_clicks').values[0].value }}</p>
          </li>
        </ul>
        <ul 
          v-else-if="post.page[0] && post.stats && post.page[0].network == 'twitter'" 
          :data="post.stats.retweet_count" 
        >
          <li>
            <img class="icon-white" src="../../assets/img/rss/icon_retweet.svg" alt="vues">
            <p>{{ post.stats.retweet_count }}</p>
          </li>
          <li>
            <img class="icon-white" src="../../assets/img/rss/icon_likes.svg" alt="likes">
            <p>{{ post.stats.favorite_count }}</p>
          </li>
          <vs-button class="btn-large" v-if="post.page[0] && post.page[0].network == 'twitter'" @click="openTweet(post)">{{ $t('dash.posts.view' )}}</vs-button>
        </ul>
      </div>

      <div class="other-actions">
        <div class="title" v-if="post.status != 'slot' && !(post._bots[0].page.isGroup && post._bots[0].page.network == 'facebook') && checkRetweet">{{ $t('dash.planner.sidebar.other-actions') }}</div>

        <vs-button class="btnx" type="filled" 
          v-if="post.status == 'slot' && !(invite || ['Writter', 'Viewer'].includes(getUserRole))"
          @click.prevent="addPost(null, null, post.date, post._bots)" 
          data-qa="post-sidebar-add-post"
        >
          {{$t('dash.button.add.post')}}
        </vs-button>

        <vs-button class="btnx" type="filled" 
          v-if="post.status == 'preview' && !(invite || ['Writter', 'Viewer'].includes(getUserRole))"
          @click.prevent="validatePost(post)" 
          :disabled="validatePostAction"
          data-qa="post-sidebar-validate-post"
        >
          {{sectionPlanner ? $t('dash.button.validate.post') : $t('dash.button.post')}}
        </vs-button>

        <vs-button class="btnx" type="filled" 
          v-if="post.status == 'preview' && !sectionPlanner && !(invite || ['Writter', 'Viewer'].includes(getUserRole)) && isUserPremiumActive"
          @click.prevent="scheduledPost(post)" 
          data-qa="post-sidebar-schedule-post"
        >
          {{ $t('dash.button.schedule')}}
        </vs-button>

        <vs-button class="btnx" type="filled" 
          v-if="post.status == 'failed' && !(invite || ['Writter', 'Viewer'].includes(getUserRole))"
          @click.prevent="editPost(post._bots[0].page.id, post._id, post.status, null, post._bots)" 
          data-qa="post-sidebar-edit-error"
        >
          {{$t('dash.button.post')}}
        </vs-button>

        <vs-button class="btnx" type="filled" 
          v-if="post.status == 'posted' && !(invite || ['Writter', 'Viewer'].includes(getUserRole)) && post.page[0].network == 'instagram' && !post.page[0].story && !post.page[0].video
          && post._bots[0].page.story_config && post._bots[0].page.story_config.created"
          @click.prevent="shareToStory(post._bots[0].page.id, post._id, post.page[0].post_number)" 
          data-qa="post-sidebar-edit-error"
        >
          {{$t('dash.button.share.story')}}
        </vs-button>

        <vs-button class="btnx delete" type="filled" 
          v-if="!(post._bots[0].page.isGroup && post._bots[0].page.network == 'facebook') && !(invite || getUserRole == 'Viewer') && ((getUserRole != 'Writter' && ((post.status == 'posted' && !post.page[0].is_retweet) || ['failed', 'scheduled', 'draft'].includes(post.status) || (post.status == 'direct' && post._bots[0].page.network != 'instagram'))) || (getUserRole == 'Writter' && post.status == 'draft')) && !(['instagram', 'oneSignal','wonderpush', 'batch', 'tiktok', 'threads', 'whatsapp'].includes(post._bots[0].page.network) && post.status == 'posted')"
          @click.prevent="deletePost(post)" 
          :disabled="(disableAddPost || editDraftNotAllowed) && post.status == 'posted'"
          data-qa="post-sidebar-delete-post"
        >
          {{$t('dash.button.delete.post')}}
          <img src="./../../assets/img/Trash-icon.svg" alt="trash">
        </vs-button>

        <vs-button class="btnx" type="filled" 
          v-if="(post.status == 'preview' || post.status == 'slot') && sectionPlanner && !(invite || ['Writter', 'Viewer'].includes(getUserRole))"
          @click.prevent="deleteSlot(post.preview_date || post.date, post._bots[0])"
          data-qa="post-sidebar-delete-slot"
        >
          {{$t('dash.button.delete.slot')}}
        </vs-button>

        <vs-button class="btnx" type="filled" 
          v-if="post.status == 'preview' && !(invite || ['Writter', 'Viewer'].includes(getUserRole))"
          @click.prevent="excludeNews(post)"
          data-qa="post-sidebar-exclude-news"
        >
          {{$t('dash.button.exclude.news')}}
        </vs-button>

        <vs-button class="btnx" type="filled" 
          v-if="post.status == 'posted' && !(invite || ['Writter', 'Viewer'].includes(getUserRole)) && !post.page[0].is_reshare && !post.page[0].is_retweet && (post._bots[0].page.network == 'facebook' || post._bots[0].page.network == 'twitter' || post._bots[0].page.network == 'linkedin')"
          @click.prevent="resharePost(post._bots[0].page.id, post._id, post.page[0])"
          data-qa="post-sidebar-reshare-post"
        >
          {{$t('dash.button.reshare')}}
        </vs-button>

        <vs-button class="btnx" type="filled" 
          v-if="checkRetweet && !(invite || ['Writter', 'Viewer'].includes(getUserRole))"
          @click.prevent="retweetPost(post._bots[0].page.id, post._id, post.page[0])"
          data-qa="post-sidebar-retweet-post"
        >
          {{$t('dash.button.retweet')}}
        </vs-button>

        <vs-button class="btnx" type="filled" 
          v-if="!(invite || ['Viewer'].includes(getUserRole))"
          @click.prevent="duplicatePost(post)"
          data-qa="post-sidebar-duplicate-post"
        >
          {{$t('dash.button.duplicate')}}
        </vs-button>
        
        <!--<vs-button class="btnx" type="filled" 
          v-if="post.status == 'posted' && gridData.pages.network == 'twitter'"
          @click.prevent="retweetPost(post._bots[0].id, post.id, post.page[0].post_number, true)"
        >
          {{$t('dash.button.unretweet')}}
        </vs-button>-->

        <template v-if="['scheduled', 'posted', 'failed', 'draft'].includes(post.status)">

          <div class="comments-title">
            {{$t('dash.post.title.notes')}}
          </div>

          <ul v-if="post.page[0] && post.page[0].comments && post.page[0].comments.length" class="comments">
            <li :key="index" v-for="(comment,index) in post.page[0].comments">
              <div v-if="post.status != 'draft' || (post.status == 'draft' && (!comment.bot || comment.bot == post._bots[0].id))">
                <p class="name">
                  {{ comment.name }}
                  <span class="date">
                    <Tooltip
                      :text="dateFormat(comment.date)"
                      position="top"
                    >
                      <span>{{ dateFromNow(comment.date) }}</span>
                      &nbsp;
                    </Tooltip>
                  </span>
                </p>
                <p class="message">{{ comment.message }}</p>
                <ul class="medias">
                  <li :key="index" v-for="(media,index) in comment.mediasUpload">
                    <a target="_blank" :href="media.url">
                      <img :src="media.url" v-if="media.type.includes('image')"/>
                      <video :src="media.url" v-else-if="media.type.includes('video')"/>
                      <img src="../../assets/img/zip_reference_icon.svg" v-else-if="media.type.includes('application/x-zip-compressed')"/>
                      <img src="../../assets/img/pdf_reference_icon.svg" v-else-if="media.type.includes('application/pdf')"/>
                      <img src="../../assets/img/document_app_essential_icon.svg" v-else/>
                      <span>{{ media.url.split('/').pop() }}</span>
                      <!-- <span class="material-icons" @click="removeFile(media)">remove</span> -->
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>

          <div class="add-comment">
            <vs-textarea
              vs-size="large"
              color="#B20564"
              name="message"
              class="inputx message"
              :placeholder="$t('dash.post.add.comment')"
              v-model="message"
            />
            <label class="uploadFile">
              <Tooltip
                :text="$t('dash.post.limit_media_note')"
                position="top"
              >
                <img src="../../assets/img/icon_paperclip.svg" />
                <input
                  type="file"
                  id="attachment"
                  name="attachment"
                  class="inputfile form-control"
                  multiple="true"
                  @change="previewFiles"
                />
                &nbsp;
              </Tooltip>
              
            </label>
            <vs-progress :percent="percentUpload" color="primary" v-if="percentUpload">primary</vs-progress> <span v-if="percentUpload">{{ percentUpload }} %</span> 
            <ul class="medias">
              <li :key="index" v-for="(media,index) in mediasUpload">
                <img :src="media.url" v-if="media.type.includes('image')"/>
                <video :src="media.url" v-else-if="media.type.includes('video')"/>
                <img src="../../assets/img/zip_reference_icon.svg" v-else-if="media.type.includes('application/x-zip-compressed')"/>
                <img src="../../assets/img/pdf_reference_icon.svg" v-else-if="media.type.includes('application/pdf')"/>
                <img src="../../assets/img/document_app_essential_icon.svg" v-else/>
                <span>{{ media.url.split('/').pop() }}</span>
                <span class="material-icons" @click="removeFile(media)">remove</span>
              </li>
            </ul>

            <vs-button class="btnx" type="filled" 
              @click.prevent="addComment()"
            >
              {{$t('dash.button.create')}}
            </vs-button>
          </div>
        </template>

      </div>
    </div>
    <vs-prompt
      color="#6a1f4c"
      @close="removePostsMultiPages = false"
      @cancel="post.status == 'draft' ? removeDraft(post._bots[0].page) : removePost()"
      :cancel-text="$t('dash.posts.multi-pages.remove.prompt.btn-only-one')"
      @accept="post.status == 'draft' ? removeDraft() : deletePostsMultiPages()"
      :accept-text="$t('dash.posts.multi-pages.remove.prompt.btn-all')"
      :title="$t('dash.posts.multi-pages.remove.prompt.title')"
      :active.sync="removePostsMultiPages"
      class="prompt-remove-posts">
        <div class="con-exemple-prompt">
          {{$t('dash.posts.multi-pages.remove.prompt.content')}}          
        </div>
    </vs-prompt>
  </div>
    
</template>

<script>
import moment from 'moment'
import PreviewPost from './PreviewPost.vue'
import ClickOutside from 'vue-click-outside'
import Bots from './../mixins/Bots'
import Posts from './../mixins/Posts'
import Insights from './../mixins/Insights'
import Common from './../mixins/Common'
import Popup from '../../utils/Popup'
import Drafts from './../mixins/Drafts'
import Notif from './../mixins/Notif'
import User from './../mixins/User'
import Tooltip from './tooltip/tooltipInit.vue'
import componentUsersSelector from './overlay/UsersSelector'
import html2canvas from'html2canvas-fitcontain'

export default {
  name: 'component-post-sidebar',

  mixins: [Common, Insights, Bots, Posts, Drafts, Notif, User],

  components: {
    PreviewPost,
    Tooltip,
    componentUsersSelector
  },

  directives: {
    ClickOutside,
  },

  props: {
    gridData: Object,
    postOriginal: Object,
    sectionPlanner: Boolean,
    invite: Boolean,
    openPostSidebar: Object
  },

  data() {
    return {
      changeNews: null,
      validatePostAction: false,
      removePostsMultiPages: false,

      message: '',
      mediasUpload: [],
      percentUpload: 0,

      postUpdated: null,

      showLogs: false,
      popupSelectUser: false
    }
  },

  mounted() {
    this.updatePost()

    if(this.openPostSidebar && this.openPostSidebar.validatePost
        && ['scheduled', 'draft'].includes(this.post.status) && this.checkWaitValidation
    ){
      this.validatePostInvite()
    }
    else if(this.openPostSidebar && this.openPostSidebar.schedulePost
        && this.post.status == 'draft' && this.openPostSidebar.id == this.post.id
    ){
      this.draftToSchedule()
    }
  },

  computed: {
    post() {
      return this.postUpdated || this.postOriginal
    },

    getUserRole() {
      const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
      if(!user) return null
      if(user.admin)
        return 'Admin'
      else
        return user.role && user.role.length
                    ? user.role[0]
                    : 'Editor'
      
    },

    getUserId() {
      const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
      if(!user) return null
      return user.id      
    },

    editDraftNotAllowed() {
      if(this.post.status == 'draft') {
        if(this.user.admin) return false
        let pages = localStorage.pages && JSON.parse(localStorage.pages) ? JSON.parse(localStorage.pages) : []
        let bots = localStorage.bots && JSON.parse(localStorage.bots) ? JSON.parse(localStorage.bots) : []
        let data = this.post.data ? this.post.data : this.post.draft.data
        let botCandEdit = data.bot.filter(bId => bots.find(bot => bot.id == bId && pages.find(p => p.id == bot.page.id)))
        return data.bot.length != botCandEdit.length
      }
      return false
    },

    getWaitValidation() {
      if(this.post.status == 'draft') {
        let wait_validation = this.post.page[0].wait_validation ? JSON.parse(this.post.page[0].wait_validation) : null
        if(wait_validation && Object.keys(wait_validation).length > 3)
          return wait_validation[this.post._bots[0].id] ? JSON.parse(wait_validation[this.post._bots[0].id]) : null
        else
          return wait_validation
      }
      return this.post.page[0].wait_validation ? JSON.parse(this.post.page[0].wait_validation) : null
    },

    checkWaitValidation() {
      if(this.post.status == 'draft' && this.post.page[0].wait_validation) {
        let wait_validation = JSON.parse(this.post.page[0].wait_validation)
        if(Object.keys(wait_validation).length > 2)
          return wait_validation[this.post._bots[0].id] ? false : true
        else
          return false
      }
      return !this.post.page[0].wait_validation
    },

    activeLog() {
      const logUser = [
        //sandbox
        'aiminne+free1@mashup-web.com',
        //prod
        "aiminne@mashup-web.com",
        "matthieu@mashup-web.com",
        "vdiakov@reworldmedia.com",
        "ldesmarecaux@reworldmedia.com",
        'ajeunet@reworldmedia.com',
        'mashup.md@reworldmedia.com',
        "a.samari@sfmd.fr",
        "egrasset@reworldmedia.com"
      ]
      const logAccount = [
        //prod
        "c93f4d0a-d1eb-4561-8071-bd4ef9fdf72a", //rcf
        "ed24f2ca-61dc-477a-9508-237845ff9423", //studiomandarine
        "da502f9e-c999-4896-baed-4e1c4110409a", //wmki
        "d2e5ed17-eaf3-4ba0-a2ba-9e1f95757776", //fcr
      ]
      const user = JSON.parse(localStorage.user)
      return logUser.includes(user.email) || logAccount.includes(user.account)
    },

    disableAddPost(){
      let bots = JSON.parse(localStorage.bots)
      let bot = null;
      if (bots) bot = bots.filter(e => e.id == this.post._bots[0].id).pop();
      if(this.post && this.post._bots){
        if((this.post._bots[0].status == 0 || (bot && bot.status === 0)) && !(this.post._bots[0].page.story_config && this.post._bots[0].page.story_config.created)) return true
        else return false
      }
      return false
    },

    hasAccessAllPage(){
      if (this.post.page[0].posts_multipages  && this.post.page[0].posts_multipages.length && this.post.page[0].posts_multipages.length > 1 && this.post.page[0].posts_multipages.map(e => e.page).every(val => val === this.post.page[0].posts_multipages[0].page)) {
        return false;
      }
      return this.getUserRole != 'Admin'
                && this.post.page[0].posts_multipages 
                && this.post.page[0].posts_multipages.length 
                && this.post.page[0].posts_multipages.length > 1
                && JSON.parse(localStorage.pages).filter(p => this.post.page[0].posts_multipages.find(m => m.page == p.id)).length != this.post.page[0].posts_multipages.length  
    },

    checkRetweet(){
      if(this.post.status == 'posted' && this.post._bots[0].page.network == 'twitter'){
        if(!this.post.page[0].is_retweet
            && !this.gridData.posts.find(p => p._id != this.post._id && p.page[0] && p.page[0].post_number == this.post.page[0].post_number && p.page[0].is_retweet)){
          return true
        }
      }
      return false
    }
  },

  watch: {
    post(){
      this.validatePostAction = false
    }
  },

  methods: {

    async updatePost() {
      if(!['draft', 'slot', 'preview'].includes(this.postOriginal.status)) {
        this.findPost(this.postOriginal._bots[0].id, this.postOriginal._id, typeof this.postOriginal.page[0].post_number == 'object' ? JSON.stringify(this.postOriginal.page[0].post_number) : this.postOriginal.page[0].post_number)
        .then(res => {
          if(res && res.body && res.body.post)
            this.postUpdated = res.body.post
            this.postUpdated._bots = this.postOriginal._bots
            this.postUpdated.status = this.postOriginal.status
            if (this.postOriginal.page[0].network === 'instagram' && this.postOriginal.page[0].storification) {
              this.postUpdated.page[0] = this.postOriginal.page[0];
            }
            if(this.postUpdated.page[0] && this.postUpdated.page[0].log && this.postUpdated.page[0].log.length)
              this.postUpdated.page[0].log = this.postUpdated.page[0].log.map(l => JSON.parse(l))

            this.postUpdated.posted_date = this.postUpdated.status == 'posted' ? res.body.post.page[0].posted_date : null
            this.postUpdated.scheduled_date = this.postUpdated.status == 'scheduled' || this.postUpdated.status == 'failed' ? res.body.post.page[0].scheduled_date : null
            this.postUpdated.preview_date = this.postUpdated.status == 'preview' ? res.body.post.preview_date : null
            this.postUpdated.date = this.postUpdated.status == 'slot' ? res.body.post.date : null
        })
        if (['scheduled', 'posted', 'failed'].includes(this.postOriginal.status) && this.postOriginal.page && this.postOriginal.page[0] && this.postOriginal.page[0].draft) {
          let draft = JSON.parse(this.postOriginal.page[0].draft);
          console.log(draft, draft.storificationData);
          this.$store.commit("updateStorification", draft.storificationData);
        }
      }
      else if(this.postOriginal.status == 'draft' || (this.postOriginal.page.length && this.postOriginal.page[0].isDraft)) {
        this.findDraft(this.postOriginal._bots[0].id, this.postOriginal._id)
        .then(res => {
          if(res && res.body && res.body.post)
            this.postUpdated = res.body.post
            this.postUpdated._bots = this.postOriginal._bots
            this.postUpdated.status = this.postOriginal.status


            this.postUpdated.id = res.body.post.id || null
            this.postUpdated._id = res.body.post.id || null
            this.postUpdated.title = this.getText(res.body.post) || null
            this.postUpdated.description = res.body.post.description || null
            this.postUpdated.url = res.body.post.url || null
            this.postUpdated.posted_date = res.body.post.status == 'posted' ? res.body.post.page[0].posted_date : null
            this.postUpdated.scheduled_date = res.body.post.status == 'scheduled' || res.body.post.status == 'failed' ? res.body.post.page[0].scheduled_date : null
            this.postUpdated.preview_date = res.body.post.status == 'preview' ? res.body.post.preview_date : null
            this.postUpdated.date = res.body.post.status == 'slot' ? res.body.post.date : null
            this.postUpdated.status = res.body.post.status
            this.postUpdated.page = res.body.post.page || null   
            this.postUpdated._bots = res.body.post._bots || null
            this.postUpdated.flux = res.body.post.flux || null

            this.postUpdated.typePost = res.body.post.draft.data.typePost
            this.postUpdated.screenshot = res.body.post.draft.data.screenshot
            this.postUpdated.videoReel = res.body.post.draft.data.videoReel
            this.postUpdated.videos = res.body.post.draft.data.videos ? JSON.parse(res.body.post.draft.data.videos) : []
            this.postUpdated.location = res.body.post.draft.data.location ? JSON.parse(res.body.post.draft.data.location) : null
            this.postUpdated.data = res.body.post.draft.data
            if (this.postOriginal.page[0] &&  this.postOriginal.page[0].storification) {
              this.postUpdated.storification = this.postOriginal.page[0].storification
              this.postUpdated.story = this.postOriginal.page[0].story
              this.postUpdated.page[0].storification = this.postOriginal.page[0].storification;
              this.postUpdated.page[0].story = this.postOriginal.page[0].story;
            }
            if(res.body.post.draft.data.log && res.body.post.draft.data.log.length) {
              this.postUpdated.page[0].log = res.body.post.draft.data.log.map(l => JSON.parse(l))
            }
            if(res.body.post.draft.data.storificationData) {
              this.$store.commit("updateStorification", res.body.post.draft.data.storificationData);
            }
            this.$forceUpdate()
        })
      }
    },

    async convertImagePreviewToBase64() {
      const getImageBase64 = async (src) => {
        if(src.includes('http://') || src.includes('https://')) {
          let res = await this.getImageFromUrl(src)
          if(res && res.body.image) return res.body.image
        }
        return src
      }
      const transformImages = async el => await [...el.getElementsByTagName('img')].map(async img => img.setAttribute('src', await getImageBase64(img.getAttribute('src'))));
      await transformImages(this.$refs[`preview-post-${this.post._bots[0].id}`]);
    },

    async addAffectedToPost(users) {
      if(users.length == 0) return
      this.popupSelectUser = false
      let body = {
        user: users[0].id,
        users: users.map(u => u.id),
        page: this.post._bots[0].page.id, 
        bot: this.post._bots[0].id, 
        post: this.post.id, 
        status: this.post.status
      }
      //screenshot
      await this.convertImagePreviewToBase64()
      setTimeout(async () => {
        await html2canvas(document.getElementById(`preview-post-${this.post._bots[0].id}`), {allowTaint: true, useCORS:true}).then(async canvas => {
          let imageB64 = canvas.toDataURL('image/png')
          const newImageBlob = await fetch(imageB64).then(res => res.blob())
          const newFile = new File([newImageBlob], `preview-post-${this.post._bots[0].id}.png`); //Blob to file
          let formData = new FormData()
          formData.append('file', newFile)
          console.log('formData', formData)
          await this.$http.post(`${process.env.VUE_APP_API_HOST}/posts/upload/file`, formData)
          .then(res => {
            body.screenshot = res.body.file_url;
            console.log('res.body.file_url', res.body.file_url)
          }, err => {
            body.screenshot = err;
            console.log('err', err)
          })
        })
      
        await this.affectedUserToPost(body)
        await this.updatePost()
        
        this.notify({
          color:'primary',
          title: this.$t('dash.post.assigned_to.success'),
          text: this.$t('dash.post.assigned_to.body') + users[0].email,
          id: 'repeat'
        })
      }, 500)
      
    },

    getVideoName(difference) {
      return JSON.parse(difference)[this.post._bots[0].page.network].split('/').pop()
    },

    getPageNameByBotId(botId){
      let bots = JSON.parse(localStorage.bots)
      let bot = bots.find(b => b.id == botId)
      return bot && bot.page && bot.page.name ? bot.page.name : botId
    },

    isDifferencesEmpty(differences) {
      if(!differences || !differences.length)
        return true
      return differences.filter(d => d && this.showLogDifference(d)).length == 0
    },

    showLogDifference(difference) {
      return !((([this.$t('dash.message.no.file'), this.$t('dash.message.no.video')].includes(difference.oldValue) && difference.newValue === null) && ['filename', 'videoname'].includes(difference.name))
                || ((difference.oldValue === null && difference.newValue == '') && !['filename', 'videoname'].includes(difference.name))
                // || ['file', 'video', 'carrouselRatio'].includes(difference.name)
                || (difference.name == 'tiktokOptions' && 'tiktok' != this.post._bots[0].page.network)
                || (difference.name == 'youtubeOptions' && 'youtube' != this.post._bots[0].page.network))
    },

    getLogUser(user) {
      if(user){
        if(user && user.id && user.name)
          return user
        else{
          return {
            id: user.id,
            name: user.id,
            avatar: false,
            email: false
          }
        }
      }
      else
        return {
          id: '',
          name: '',
          avatar: false,
          email: false
        }
    },

    getContentLog(log) {
      return JSON.parse(log)
    },

    getDateLog(log) {
      console.log('getDateLog', log)
      return moment(log.created_at || log.updated_at || log.removed_at).local().format('DD/MM/YY HH:mm')
    },

    async previewFiles(e) {
      const { VUE_APP_API_HOST } = process.env 
      console.log('nombre d images', e.target.files.length)
      console.log(e.target.files)
      for (var file of e.target.files) {
        if(file.size > 50 * 1024 * 1024){
          this.notify({
            title: this.$t('dash.notifications.error_title'),
            text: this.$t('dash.notifications.limit_file_exceeded') + " (50 Mo max)",
            color:'success',
            time: 10000,
            id: 'norepeat'
          })
          continue
        }
        let formData = new FormData()
        formData.append('file', file)
        await this.$http
          .post(`${VUE_APP_API_HOST}/posts/upload/file`, formData, {
            progress: (e) => {
                if (e.lengthComputable) {
                    console.log(Math.floor(e.loaded / e.total * 100));
                    this.percentUpload = Math.floor(e.loaded / e.total * 100)
                }
            }
          })
          .then(res => {
            this.mediasUpload.push({
              url: res.body.file_url,
              type: file.type
            })
          }, err => err)
      }
      this.percentUpload = 0
      console.log(this.mediasUpload)      
    },

    removeFile(media) {
      this.mediasUpload = this.mediasUpload.filter(m => m.url != media.url)
    },

    getText(entry, title=false){

      let text = entry._bots && entry._bots.post_text_layout == 'description' ? entry.description : entry.title

      if(title) text = entry.title

      if(!text) text = ""

      // let maxWhile = 100
      // let countWhile = 0
      // if(entry.draft){
      //   //replace multi-mention
      //   while(text.includes('@[MENTIONS-') && countWhile<maxWhile){
      //     countWhile++
      //     let start = text.indexOf('@[MENTIONS-')
      //     let end = text.indexOf(']', start)
      //     let index = parseInt(text.substr(start, end+1).replace('@[MENTIONS-', '').replace(']', ''))
      //     let mention = entry.draft.data.validMentions[index-1].find(m => m.network == entry._bots[0].page.network)
      //     if(mention && mention.value) 
      //       switch(mention.network){
      //         case 'twitter':
      //         case 'instagram':
      //           mention = mention.value.includes('@[') ? `@${mention.value.substring(2, mention.value.indexOf('('))}` : mention.value
      //           break
      //         case 'facebook':
      //         case 'linkedin':
      //           mention = mention.value.substring(2, mention.value.indexOf('('))
      //           break
      //         default:
      //     }
      //     else if(mention && mention.word){
      //       mention = mention.word
      //     }
      //     text = text.substr(0, start) + (mention ? mention : entry.draft.data.validMentions[index-1][0].word) + text.substr(end+1)
      //   }
      // }

      // countWhile = 0
      // //replace mention affected
      // while(text.includes('@[') && countWhile<maxWhile){
      //   countWhile++
      //   let start = text.indexOf('@[')
      //   let end = text.indexOf(']', start)
      //   let mention = {
      //     network: entry._bots[0].page.network,
      //     value: text.substr(start, end-start+1)
      //   }
      //   if(mention) 
      //     switch(mention.network){
      //       case 'twitter':
      //       case 'instagram':
      //         mention = mention.value
      //         break
      //       case 'facebook':
      //       case 'linkedin':
      //         mention = `@${mention.value.substring(2, mention.value.indexOf('('))}`
      //         break
      //       default:
      //     }
      //   text = text.substr(0, start) + (mention ? mention : '') + text.substr(end+1)

      //   if(text && text.length > 280)
      //     text = text.substr(0, text.substr(0, 280 - 4).lastIndexOf(" ")) + " ..."
      // }

      return text
      },

    formatDate(dateToFormat, format) {
      return moment(dateToFormat)
        .local()
        .format(format)
    },

    formatDayEn(dateToFormat, format) {
      return moment(dateToFormat)
        .locale('en')
        .format(format)
    },

    formatDateToUTC(date){
      let year = new Date(date).getUTCFullYear()

      let month = new Date(date).getUTCMonth() + 1
      month = month < 10 ? `0${month}` : month
      
      let day = new Date(date).getUTCDate()
      day = day < 10 ? `0${day}` : day

      let hour = new Date(date).getUTCHours()
      hour = hour < 10 ? `0${hour}` : hour
      
      let minute = new Date(date).getUTCMinutes()
      minute = minute < 10 ? `0${minute}` : minute

      let seconde = new Date(date).getUTCSeconds()
      seconde = seconde < 10 ? `0${seconde}` : seconde

      return `${year}-${month}-${day}T${hour}:${minute}:${seconde}`
    },

    editPost(page, id, status, slotDate=null, bot=null){
      if(status == "preview") this.$emit('edit', page, id, status, true, slotDate, bot)
      else if(status == "scheduled") this.$emit('edit', page, id, status)
      // else if(status == "failed") this.$emit('edit', page, id, status)
      else if(status == "failed") this.$emit('duplicatePost', this.post._bots[0].page.id, this.post, true)
      else if(status == "draft") this.$emit('editDraft', this.post)
    },

    shareToStory(page, id, media) {
      this.$emit('shareStory', page, id, media)
    },

    validatePost(post){
      console.log('val', post)
      this.validatePostAction = true
      this.changeNews = post._id
      this.changePost(post)
    },

    scheduledPost(post){
      this.$emit('edit', this.post._bots[0].page.id, post._id, post.status, false, moment().add(11, 'minutes'), post._bots)
    },

    changePost(post){
      if(!this.sectionPlanner)
        post.preview_date = moment().utc().format()
      let news = this.gridData.posts.find(p => p._id == this.changeNews)
      console.log('news', news)
      let scheduledDate = moment(post.preview_date).utc().format()
      let body = {
        bot: post._bots[0].id,
        service: post._bots[0].service,
        data: {
          title: post._bots[0].post_text_layout == 'title' ? news.title : (post._bots[0].post_text_layout == 'description' ? news.description : ''),
          description: news.description || null,
          message: post._bots[0].post_text_layout == 'title' ? news.title : (post._bots[0].post_text_layout == 'description' ? news.description : ''),
          // url: news.url || '',
          url: this.getUrlWithUtm() || '',
          scheduled_date: scheduledDate,
          postImage: post._bots[0].mode == 'image' ? true : false,
          enclosure: news.enclosure || null,
          typePost: post._bots[0].mode === 'story' && !(post._bots[0].page.story_config && !(post._bots[0].page.story_config && !post._bots[0].page.story_config.created) ) ? 'standard' : post._bots[0].mode,
          original: post._id,
          flux: post.flux && post.flux.id ? post.flux.id : null,
          allBots: post._bots[0].uid
        }
      }
      if(post._bots[0].hashtagPrefix) body.data.message = post._bots[0].hashtagPrefix + ' ' + body.data.message
      if(post._bots[0].hashtag) body.data.message += ' ' + post._bots[0].hashtag 
      body.data['id'] = post._id
      body.data.title = body.data.message
      if(post._bots[0].linkInComments) {
        body.data.removeUrlInMessage = true
        // body.data.comments = JSON.stringify([body.data.url])
        body.data.comments = JSON.stringify([this.getUrlWithUtm()])
      }
      body = { ...body, scheduled: this.sectionPlanner ? true : false }
      this.$emit('validate', body)  
      this.deleteSlot(post.preview_date, post._bots[0], false)
    },

    getUrlWithUtm(){
      if (this.post && !!this.post.url && !!this.post.url.trim().length) {
        if(this.post._bots && this.post._bots[0] && this.post._bots[0].utm_source){
          // Add UTM params to URL
          const newsUrl = new URL(this.post.url)
          const utmParams = new URLSearchParams(this.post._bots[0].utm_source)
          for (const [k, v] of utmParams) {
            newsUrl.searchParams.set(k, v)
          }
          return newsUrl.href
        }
        else return this.post.url
      }
    },
    
    async deletePost(post){

      if(post.status == 'draft') {
        if(post.data && post.data.bot && post.data.bot.length > 1){
          this.removePostsMultiPages = true
        }
        else {
          let confirmDelete = await new Promise((resolve, reject) => {
            this.$vs.dialog({
              type:'confirm',
              color: 'primary',
              title: this.$t('dash.posts.confirm.delete_draft.title'),
              text: this.$t('dash.posts.confirm.delete_draft.body'),
              cancelText: this.$t('dash.posts.confirm.delete_draft.btn-cancel'),
              cancel: async () => {        
                resolve(false);
              },
              acceptText: this.$t('dash.posts.confirm.delete_draft.btn-remove'),
              accept: async () => {        
                resolve(true);
              }
            })
          })
          if(confirmDelete)
            this.removeDraft()
        }
      }
      else if(post.status == 'direct'){
        this.$emit('deleteScheduled', post)
      }
      else {
        let news = this.gridData.posts.find(p => p._id == this.post._id)
        let multipages = this.post.page && this.post.page.length && this.post.page[0].posts_multipages ? this.post.page[0].posts_multipages.reduce((acc, val) => {
          if (!acc.map(e => e.bot).includes(val.bot)) {
            acc.push(val);
          }
          return acc;
        }, []) : []
        console.log("multipages", multipages);
        if(this.post.page && this.post.page.length && this.post.page[0].posts_multipages && this.post.page[0].posts_multipages.length && multipages.length > 1
                && (this.getUserRole == 'Admin' || JSON.parse(localStorage.pages).filter(p => multipages.find(m => m.page == p.id)).length == multipages.length)){
          this.removePostsMultiPages = true
        }
        else {
          let confirmDelete = await new Promise((resolve, reject) => {
            this.$vs.dialog({
              type:'confirm',
              color: 'primary',
              title: this.$t('dash.posts.confirm.delete_post.title'),
              text: this.$t('dash.posts.confirm.delete_post.body'),
              cancelText: this.$t('dash.posts.confirm.delete_post.btn-cancel'),
              cancel: async () => {        
                resolve(false);
              },
              acceptText: this.$t('dash.posts.confirm.delete_post.btn-remove'),
              accept: async () => {        
                resolve(true);
              }
            })
          })
          if(confirmDelete)
            this.removePost(news)
        }
      }
    },

    removeDraft(page=null){
      this.deleteDraft(this.post.id, page)
      this.$emit('removeDrafts', this.post.id)
    },

    removePost(news){
      this.removePostsMultiPages = false
      if(!news)
        news = this.gridData.posts.find(p => p._id == this.post._id)
      let current_story = this.post.page && this.post.page.length && this.post.page[0].posts_multipages ? this.post.page[0].posts_multipages.find(e => e._id === news.id && e.story) : null
      let multistory = current_story && this.post.page[0].posts_multipages ? this.post.page[0].posts_multipages.filter(e => {
        return e.bot === current_story.bot && e.story
      }) : []
      console.log(multistory, current_story, news);
      if (multistory.length > 1) {
        multistory.forEach(p => {
          news._id = p._id
          news.id = p._id
          if(news._bots && news._bots[0] && news._bots[0].id)
            news._bots[0].id = p.bot
          else
            news._bots.id = p.bot
          news.page[0].post_number = p.postId
          news.page[0].status = p.status
          this.$emit('deleteScheduled', news)
        })
      } else {
        this.$emit('deleteScheduled', news)
      }
    },

    deletePostsMultiPages(){
      this.removePostsMultiPages = false
      if(this.post.page[0].posts_multipages && this.post.page[0].posts_multipages.length){
        let news = this.gridData.posts.find(p => p._id == this.post._id)
        this.post.page[0].posts_multipages.forEach(p => {
          news._id = p._id
          news.id = p._id
          if(news._bots && news._bots[0] && news._bots[0].id)
            news._bots[0].id = p.bot
          else
            news._bots.id = p.bot
          news.page[0].post_number = p.postId
          news.page[0].status = p.status
          this.$emit('deleteScheduled', news)
        })
      }
    },

    resharePost(pageId, newsId, pageEmbed){
      this.$emit('resharePost', pageId, newsId, pageEmbed)
    },

    retweetPost(pageId, newsId, pageEmbed){
      this.$emit('retweetPost', pageId, newsId, pageEmbed)
    },
    retweetPostOLD(bot, news_id, retweet_id, unretweet=false){
      this.$emit('retweetPost', bot, news_id, retweet_id, unretweet)
    },

    duplicatePost(post) {
      console.log('duplicatePost', post)
      this.$emit('duplicatePost', post._bots[0].page.id, post)
    },

    async excludeNews(post){
      await this.excludeNewsToPost(post._bots[0].id, post)
      .then(() => {
        this.$emit('excludeNews', post._bots[0], post)

        if(this.activeLog){
          let messageLog = ` --- ${post}`
          this.addLog(JSON.parse(localStorage.user), 'exclude-news', messageLog)
        }
      })
    },

    async deleteSlot(date, bot, refresh=true){
      console.log('deleteSlot', bot)
      date = this.formatDate(date, 'YYYY-MM-DDTHH:mm:ss')
      date = this.formatDateToUTC(date)
      if(this.sectionPlanner && refresh) this.$vs.loading({color : 'primary'})
      await this.deleteSlotByBot(bot.id, date).then(async res => {

        if(this.sectionPlanner && refresh) this.$vs.loading.close()

        const { success } = res.body

        if(this.activeLog){
          let messageLog = `${res.url} --- ${res.bodyText}`
          this.addLog(JSON.parse(localStorage.user), 'delete-slot', messageLog)
        }

        if (!success) {
          const notif = {
            color:'primary',
            title: this.$t('dash.posts.error.title'),
            text: this.$t('dash.scheduler.error.delete_slot'),
            id: bot.id
          }
          this.notify(notif, {
            component: "PostSidebar",
            action: "deleteSlot",
            params: {
              botId: bot.id, 
              date: date
            }
          })
          return
        }
        
        if(refresh) this.$emit('deleteSlot', bot)
      })
    },  

    addPost(day, hour, date=null, bot=null){
        if(date){
          day = moment(date).local().hours(0).minutes(0).seconds(0)
          hour = moment(date).local().hours()
          let minute = moment(date).local().minutes()
          this.$emit('add', true, day, hour, minute, true, date, bot)
        } 
        else if(day.hours(hour).unix() > moment().minutes(0).seconds(0).unix())
          this.$emit('add', true, day, hour)
    },

    openTweet(entry){
      const username = entry._bots.find(b => b.uid == entry.page[0].id).page.name
      Popup.open(`https://www.twitter.com/${username}/status/${entry.page[0].post_number}`, '', 900, 700)
    },

    openLinkedin(entry) {
      if (entry.page[0].post_number_bis) {
        Popup.open(`https://www.linkedin.com/feed/update/${entry.page[0].post_number_bis}`, '', 900, 700);
      } else {
        this.getLinkedinPost(entry._bots[0].page.id, entry.page[0].post_number).then(async res => {
          const { success, post } = res.body
          if(success && post && post.activity)
            Popup.open(`https://www.linkedin.com/feed/update/${post.activity}`, '', 900, 700)
          else if(success && post && post.id)
            Popup.open(`https://www.linkedin.com/feed/update/${post.id}`, '', 900, 700)
        })
      }
      
    },

    openThreads(entry) {
      const username = entry._bots.find(b => b.uid == entry.page[0].id).page.name
      Popup.open(`https://www.threads.net/@${username}`, '', 900, 700)

      // this.getThreadsPost(entry._bots[0].page.id, entry.page[0].post_number).then(async res => {
      //   const { success, post } = res.body
      //   if(success && post && post.permalink)
      //     Popup.open(post.permalink, '', 900, 700)
      // })
    },

    openFacebook(entry) {
      Popup.open(`https://www.facebook.com/${entry.page[0].post_number}`, '', 900, 700)
    },

    openPinterest(entry){
      Popup.open(`https://www.pinterest.fr/pin/${entry.page[0].post_number}`, '', 900, 700)
    },

    // openGoogle(entry){
    //   Popup.open(entry.page[0].post_number_bis, '', 900, 700)
    // },
    openGoogle(entry){
      if(entry.page[0].post_number_bis)
        Popup.open(entry.page[0].post_number_bis, '', 900, 700)
      else {
        this.getGooglePost(entry._bots[0].page.id, entry.page[0].post_number).then(async res => {
          const { success, searchUrl } = res.body
          if(success && searchUrl)
            Popup.open(searchUrl, '', 900, 700)
          else {
            this.notify({
              color:'primary',
              title: this.$t('dash.posts.error.title'),
              text: this.$t('dash.post.linkedin.error_show_post'),
              time: 4000,
              id: null
            })
          }
        })
      }
    },

    openYoutube(entry){
      Popup.open(`https://www.youtube.com/watch?v=${entry.page[0].post_number}`, '', 900, 700)
    },

    showPost(page, post){
      console.log('showPost', page, post)
      switch(page.network){
        case 'facebook':
          this.openFacebook(post)
          break
        case 'twitter': 
          this.openTweet(post)
          break
        case 'linkedin': 
          this.openLinkedin(post)
          break
        case 'pinterest':
          this.openPinterest(post)
          break
        case 'google':
          this.openGoogle(post)
          break
        case 'youtube':
          this.openYoutube(post)
          break
        case 'threads':
          this.openThreads(post)
          break
        default:
      }
    },

    draftToSchedule() {
      // this.$emit('validateDraft', this.post)
      this.$vs.dialog({
        type:'confirm',
        color: 'primary',
        title: this.$t(`dash.posts.multi-pages.validate_draft_to_post${this.post.data.bot.length > 1 ? 's' : ''}.title`),
        text: this.$t(`dash.posts.multi-pages.validate_draft_to_post${this.post.data.bot.length > 1 ? 's' : ''}.body`),
        cancelText: this.$t('dash.button.cancel'),
        acceptText: 'OK',
        accept: async () => {
          this.$emit('validateDraft', this.post)
        }
      })
    },

    validatePostInvite() {
      if((this.post.status == 'draft' && (this.post.data || this.post.draft.data).bot.length > 1)
          || (this.post.page && this.post.page[0] && this.post.page[0].posts_multipages)) {

            this.$vs.dialog({
              type:'confirm',
              color: 'primary',
              title: this.$t('dash.posts.multi-pages.validate_post.title'),
              text: this.$t('dash.posts.multi-pages.validate_post.body'),
              cancelText: this.$t('dash.posts.multi-pages.remove.prompt.btn-only-one'),
              cancel: async () => {
                this.$emit('validateScheduledPost', this.post)
              },
              acceptText: this.$t('dash.posts.multi-pages.remove.prompt.btn-all'),
              accept: async () => {
                this.$emit('validateScheduledPost', this.post, true)
              }
            })
      }
      else
        this.$emit('validateScheduledPost', this.post)
    },

    // addComment() {
    //   if(this.message && this.message.trim() != '') {
    //     this.$emit('addComment', this.post, this.message)
    //     this.message = ''
    //   }
    // },
    addComment() {
      if(this.message && this.message.trim() != '') {
        if((this.post.status == 'draft' && (this.post.data || this.post.draft.data).bot.length > 1)
          || (this.post.page && this.post.page[0] && this.post.page[0].posts_multipages)) {

            this.$vs.dialog({
              type:'confirm',
              color: 'primary',
              title: this.$t('dash.posts.multi-pages.add_note.title'),
              text: this.$t('dash.posts.multi-pages.add_note.body'),
              cancelText: this.$t('dash.posts.multi-pages.remove.prompt.btn-only-one'),
              cancel: async () => {
                this.$emit('addComment', this.post, this.message, this.mediasUpload)
                this.message = ''
                this.mediasUpload = []
              },
              acceptText: this.$t('dash.posts.multi-pages.remove.prompt.btn-all'),
              accept: async () => {
                this.$emit('addComment', this.post, this.message, this.mediasUpload, true)
                this.message = ''
                this.mediasUpload = []
              }
            })
        }
        else {
          this.$emit('addComment', this.post, this.message, this.mediasUpload)
          this.message = ''
          this.mediasUpload = []
        }
      }
    },

    dateFromNow(date){
      return moment(date).fromNow(0)    
    },

    dateFormat(date, HH=null, mm=null){
      if(HH && mm)
        return  moment(date).local().hours(HH).minutes(mm).format('LLL')
      return moment(date).local().format('LLL')
    },

  }
}    
</script>